export default __webpack_public_path__ + "8f965677ced3fea877adf12ba838aa73.svg";